






























































































import { Vue, Component, Watch } from 'vue-property-decorator';
import * as config from './config';
import { Tab, Tabs, List } from 'vant';
import { typeListAll, voteList, userHelper } from './api/index';
import { getRules } from '@/api/api';
import SearchInput from '@/components/SearchInput.vue';
import { appShare, wxShareInfo } from '@/common/ts/common';
import { namespace, State } from 'vuex-class';
import * as mutationTypes from './store/mutation-types';

const Modules = namespace('EatWithGoodManner20200812');
Vue.use(Tab).use(Tabs).use(List);
@Component({
  name: 'eat-with-good-manner-First',
  components: {
    SearchInput,
  },
})
export default class First extends Vue {
  option = config.OPTHINES;
  // active = 0;
  offset = 300;
  loading = false;
  finished = false;
  page = 1;
  loadingStatus = true;
  SearchData = '';
  num = 0;
  timer: any;
  List: any[] = [];
  typeAllList: any[] = [];
  listSwitch: boolean = true;
  Rules = '';
  boxHeight = 0;

  @Modules.Mutation(mutationTypes.RECORD_ACTIVE_NUM) recordActiveNum!: (
    activeNum: any,
  ) => void;
  @Modules.State('activeNum') active!: {};

  get activeNum() {
    return this.active;
  }
  set activeNum(val) {
    console.log('val', val);
  }
  reset() {
    this.List = [];
    this.page = 1;
    this.loading = false;
    this.finished = false;
    this.loadingStatus = true;
  }
  created() {
    userHelper().then((res) => (this.num = res.data));
    // this.onLoad();
    getRules(this.option.voteName).then((res: any) => (this.Rules = res.data));
    typeListAll().then((res) => {
      this.typeAllList = res.data;
    });
    // 分享
    appShare({
      title: '人和街小学四年级（2016级）“我十岁啦”作文展',
      url: window.location.href,
      subtitle: '人和街小学四年级（2016级）“我十岁啦”作文展',
      classId: -1,
      id: -1,
      image: 'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
      type: 3,
    });
    wxShareInfo({
      title: '人和街小学四年级（2016级）“我十岁啦”作文展',
      subtitle: '人和街小学四年级（2016级）“我十岁啦”作文展',
      image: 'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
    });
  }
  mounted() {
    const boxWrapperEl = (this.$refs.boxWrapper as HTMLDivElement)!;
    const bottomTabbarEl = document.querySelector('.van-hairline--top-bottom')!;
    this.boxHeight =
      window.innerHeight -
      boxWrapperEl.offsetTop -
      bottomTabbarEl.clientHeight -
      20;
  }
  onLoad(change?: string) {
    this.loading = true;
    console.log('is change here?:', change);
    console.log('$ccurrent finished status is:', 'color: blue', this.finished);
    // console.log('onLoad开始');
    if (this.loadingStatus && !this.finished) {
      if (this.activeNum === 2) {
        voteList({
          page: this.page,
        }).then((res) => {
          if (change) {
            console.log('clear list from', this.activeNum, change);
            // this.List = [];
          }
          this.endListData(res);
        });
      }
    }
  }
  endListData(res: any) {
    this.page = this.page + 1;
    // console.log(res.data)
    if (!res.data || res.data.length === 0) {
      this.finished = true;
      console.log('%chas no data', 'color: red');
    } else {
      this.List = [...this.List, ...res.data];
    }
    this.loading = false;
  }
  onClick(index: any) {
    this.listSwitch = false;
    setTimeout(() => {
      this.listSwitch = true;
    }, 500);
    this.reset();
    this.recordActiveNum(index);
    console.log('this.activeNum', this.activeNum);
  }
  enterSearch() {
    this.$router.push({
      path: './SearchPage',
    });
  }
  enterList(p: any) {
    this.$router.push({
      path: './ListPage',
      query: { type: p },
    });
  }
  enterDetail(item: any, index: number, type: 'all' | 'hot') {
    this.$routerThen
      .push({
        url: `detail?id=${item.id}`,
      })
      .then((vm) => {
        vm.$on('voteUpdate', () => {
          if (type === 'hot') {
            this.List[index].votes = Number(this.List[index].votes) + 1;
          }
        });
      });
  }
}
